import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { FormStore } from 'core/forms/FormStore';

import { TwoColumnLayoutHOC } from 'containers/layouts/TwoColumnLayout/TwoColumnLayoutHOC';
import { myAccountHOC } from 'containers/MyAccount/MyAccount';

import UserDetailsDescription from './UserDetailsDescription';

import UserDetailsForm from './UserDetailsForm';

import userDetailsFormValues from './userDetailsFormValues';

import { localeStrings as strings } from 'applicationConfig';

const formStore = new FormStore(userDetailsFormValues);

@inject('userStore', 'settingsStore')
class UserDetails extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    return this.props.userStore.saveUserDetails(formStore.getFormValues()).then(() => {
      this.props.settingsStore.showSimpleAlert(strings.myAccount.userDetailsTab.userDetailsUpdateSuccess);
    });
  }

  componentWillMount() {
    this.props.userStore.getUserDetails().then((details) => {
      formStore.setFormValues(details, true);
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <UserDetailsForm onSubmit={this.onSubmit} formStore={formStore} formLabels={strings.myAccount.userDetailsTab} />
      </div>
    );
  }
}

export default myAccountHOC(TwoColumnLayoutHOC(UserDetails, UserDetailsDescription));



// WEBPACK FOOTER //
// ./src/containers/MyAccount/UserDetails/UserDetails.jsx